export default "__VITE_ASSET__DHGki8xF__"